// Parent Home, behind 003's gate: a parent with no children is sent to the join or the Enter school
// code step first (FR-027, FR-028). The hero shows the selected child's school banners (007; 005 slice).
import { ParentHomeGate } from "@/join/ParentHomeGate";
import { HomeScreen } from "@/home/HomeScreen";

export default function Home() {
  return (
    <ParentHomeGate>
      <HomeScreen />
    </ParentHomeGate>
  );
}
